'use strict';

function FormAppSubmitGroupService($resource, config) {
  return $resource(config.apiBase + '/companies/:companyId/form-groups/:groupId', {}, {
    'update': { method: 'PUT' },
    'getMyFormAppGroups': {
    	method: 'GET',
    	url: config.apiBase + '/companies/:companyId/groups?userId=:userId',
    	isArray: true
    }
  });
}

angular.module('dokiv')
  .factory('FormAppSubmitGroupService', ['$resource', 'config', FormAppSubmitGroupService]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/form-app-submit-group/FormAppSubmitGroupService.js
// module id = 40
// module chunks = 0